import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Eyebrow, Reveal, WhatsAppButton } from "@/components/bits";

/* --------------------------------- 18. FAQ --------------------------------- */
const faqs = [
  {
    q: "Donna Virtuosa è terapia?",
    a: "No. Donna Virtuosa è un percorso di Life Coaching Cristiano. Non sostituisce psicoterapia, psichiatria, assistenza medica o altre professioni sanitarie.",
  },
  {
    q: "Chiara è una psicologa?",
    a: "No. Chiara Perrone è una Life Coach Cristiana.",
  },
  {
    q: "Chiara è una pastora?",
    a: "No. Chiara non viene presentata come pastore o autorità ecclesiastica. Donna Virtuosa è un percorso di Life Coaching Cristiano.",
  },
  {
    q: "Devo essere cristiana per partecipare?",
    a: "Il percorso nasce da una visione cristiana e utilizza principi biblici. Per questo è particolarmente indicato per donne che desiderano vivere un percorso di crescita personale mettendo Dio al centro.",
  },
  {
    q: "È un percorso individuale?",
    a: "Sì. Donna Virtuosa è un percorso One to One.",
  },
  {
    q: "Possiamo parlare anche di matrimonio e relazioni?",
    a: "Sì. Relazioni, comunicazione, confini, matrimonio, famiglia e responsabilità personali possono essere parte del percorso quando rilevanti per la situazione della persona.",
  },
  {
    q: "Possiamo lavorare anche su corpo e disciplina?",
    a: "Sì. Donna Virtuosa considera la persona nella sua interezza. Per questo possono essere affrontate routine, abitudini, rapporto con il corpo, disciplina e stile di vita.",
  },
  {
    q: "Posso partecipare se sono single?",
    a: "Sì. Donna Virtuosa non è un percorso esclusivamente matrimoniale. È rivolto alla donna nella sua interezza.",
  },
  {
    q: "Posso partecipare se sto attraversando una separazione o una fase difficile?",
    a: "Potenzialmente sì. Il primo confronto serve anche a capire se il coaching sia adeguato alla situazione oppure se sia opportuno rivolgersi a un'altra figura professionale.",
  },
  {
    q: "Come faccio a capire se fa per me?",
    a: "Scrivi direttamente a Chiara su WhatsApp. Raccontale brevemente cosa stai vivendo e da lì capirete insieme se Donna Virtuosa può essere coerente con ciò di cui hai bisogno.",
  },
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="scroll-mt-24">
    <div className="mx-auto max-w-3xl px-6 py-24 md:px-10 md:py-36">
      <Reveal>
        <Eyebrow>Domande frequenti</Eyebrow>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 font-serif text-3xl leading-tight tracking-tight text-[#1A1818] md:text-5xl">
          Tutto quello che vuoi sapere
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={faq.q}
              value={`faq-${i}`}
              className="border-b border-[#2A2421]/15"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="py-6 text-left font-serif text-lg text-[#1A1818] transition-colors duration-300 hover:text-[#A98A2C] hover:no-underline md:text-xl [&>svg]:text-[#A98A2C]">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-[#3A3532]">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

/* ------------------------- 19. SEZIONE FINALE EMOZIONALE ------------------------- */
const finaleLines = [
  "Forse alcune cose non sarebbero dovute accadere.",
  "Forse hai commesso errori.",
  "Forse hai permesso cose che oggi non permetteresti più.",
  "Forse hai perso persone.",
  "Forse sei stata ferita.",
  "Forse hai ferito.",
  "Forse hai attraversato una stagione che non avresti mai scelto.",
];

const finaleRebuild = [
  "Puoi iniziare a guardarti con verità.",
  "Puoi imparare.",
  "Puoi assumerti responsabilità.",
  "Puoi ricostruire.",
  "Puoi crescere.",
  "Puoi tornare a prenderti cura del tuo cuore.",
];

export const Finale = () => (
  <section data-testid="finale-section" className="bg-[#1A1818] text-[#FDFBF7]">
    <div className="mx-auto max-w-4xl px-6 py-24 md:px-10 md:py-40">
      <Reveal>
        <h2 className="font-serif text-3xl leading-tight tracking-tight sm:text-4xl md:text-6xl">
          Non puoi cambiare la ragazza che eri.
          <span className="mt-4 block text-[#D4AF37]">
            Puoi prenderti cura della donna che stai diventando.
          </span>
        </h2>
      </Reveal>
      <div className="mt-14 space-y-2">
        {finaleLines.map((line, i) => (
          <Reveal key={line} delay={0.05 * i}>
            <p className="text-base text-[#FDFBF7]/70 md:text-lg">{line}</p>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.1}>
        <p className="mt-10 font-serif text-2xl italic text-[#FDFBF7] md:text-3xl">Ma sei ancora qui.</p>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-8 space-y-2 text-base text-[#FDFBF7]/70 md:text-lg">
          <p>E quello che è successo può spiegare una parte di te.</p>
          <p>Non deve necessariamente governare tutta la tua vita.</p>
        </div>
      </Reveal>
      <div className="mt-10 space-y-2">
        {finaleRebuild.map((line, i) => (
          <Reveal key={line} delay={0.05 * i}>
            <p className="font-serif text-xl text-[#FDFBF7] md:text-2xl">{line}</p>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-10 font-serif text-2xl italic text-[#D4AF37] md:text-3xl">
          E puoi farlo mettendo Dio al centro.
        </p>
      </Reveal>
    </div>
  </section>
);

/* ------------------------------- 20. CTA FINALE ------------------------------- */
const ctaFinalPoints = [
  "Ricostruisci il cuore.",
  "Impara a governare le emozioni.",
  "Ristabilisci confini.",
  "Prenditi cura del corpo.",
  "Coltiva relazioni più sane.",
  "Ritrova disciplina.",
  "Riscopri la tua voce.",
  "Cammina con Dio.",
];

export const CtaFinale = () => (
  <section data-testid="cta-finale-section" className="relative overflow-hidden bg-[#F4EFE6]">
    <div className="relative mx-auto max-w-4xl px-6 py-24 text-center md:px-10 md:py-40">
      <Reveal>
        <h2 className="font-serif text-3xl leading-tight tracking-tight text-[#1A1818] sm:text-4xl md:text-6xl">
          È tempo di prenderti cura della donna che stai diventando.
        </h2>
      </Reveal>
      <div className="mx-auto mt-12 grid max-w-2xl grid-cols-1 gap-x-10 sm:grid-cols-2">
        {ctaFinalPoints.map((p, i) => (
          <Reveal key={p} delay={0.04 * i}>
            <p className="border-b border-[#2A2421]/15 py-3 text-left text-base text-[#3A3532] md:text-lg">{p}</p>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <div className="mt-14">
          <WhatsAppButton label="Parla con Chiara" testid="cta-finale-whatsapp" className="px-12 py-5 text-base" />
          <p className="mx-auto mt-6 max-w-md text-sm leading-relaxed text-[#3A3532]">
            Raccontami in poche parole dove sei oggi. Ti risponderò personalmente per capire se
            Donna Virtuosa può essere il percorso giusto per te.
          </p>
          <p className="mx-auto mt-6 max-w-md font-serif text-base italic text-[#3A3532]/80">
            “Ciao Chiara, ho letto di Donna Virtuosa e vorrei capire meglio il percorso.”
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

/* --------------------------------- 21. FIRMA --------------------------------- */
export const Firma = () => (
  <section data-testid="firma-section" className="border-t border-[#2A2421]/10">
    <div className="mx-auto max-w-4xl px-6 py-20 text-center md:px-10 md:py-28">
      <Reveal>
        <p className="font-serif text-5xl italic tracking-tight text-[#1A1818] md:text-6xl" data-testid="firma-name">
          Chiara Perrone
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-6 space-y-1 text-xs font-semibold uppercase tracking-[0.22em] text-[#3A3532]/70">
          <p>Life Coach Cristiana</p>
          <p>Founder Donna Virtuosa</p>
          <p>Co-Founder Fede &amp; Fitness Italia</p>
        </div>
      </Reveal>
    </div>
  </section>
);
